<template>
    <section class="locations-listing">
        <div v-for="location in locations" :key="location.id" class="location">
            <div class="image-text-wrapper">
                <div class="flex">
                    <div class="image">
                        <img :src="location.avatar" :alt="location.building_name" />
                    </div>
                    <div class="text">
                        <h3 class="title" v-if="location.building_name">{{ location.building_name }}</h3>
                        <p>
                            <strong>Address: </strong>
                            <template v-if="location.address && location.address.length">
                                <span v-html="location.address.join(' ')"></span>
                            </template>
                        </p>
                        <p>
                            <strong>Contact: </strong>
                            <span v-if="location.phone">
                                Phone:
                                <a :href="`tel:${location.phone_clickable}`">{{ location.phone }}</a>
                            </span>
                            <span v-if="location.fax">| Fax: {{ location.fax }}</span>
                        </p>
                        <p>
                            <strong>Clinic Hours: </strong>
                            <span v-if="location.clinic_hours">{{ location.clinic_hours }}</span>
                        </p>
                        <p>
                            <strong>Treatment Hours: </strong>
                            <span v-if="location.treatment_hours">{{ location.treatment_hours }}</span>
                        </p>
                    </div>
                </div>
            </div>

            <div class="actions">
                <a :href="`http://maps.google.com/?q=${location.coordinates['lat']},${location.coordinates['lng']}`"
                 target="_blank" role="button">
                    <i aria-hidden="true" class="fas fa-map-marked-alt"></i>
					<span>Get Directions</span>
				</a>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    props: {
        locations: {type: Array, required: true},
    },

    data() {
        return {

        };
    },

    methods: {
        withLineBreaks(value) {
            return value.join('<br />');
        },
    },
};
</script>
